export default __webpack_public_path__ + "static/media/warning-icon.1e5e23e5.png";